import { Alert, AlertTitle, Box } from "@mui/material";
import Header from "../../../../components/Header";

const CuadreLegacyNotAllowed = () => {

  return (
    <Box m="20px" marginBottom="64px">
      <Header title="Cuadre" subtitle="No permitido"/>
      <Alert severity="warning">
        <AlertTitle sx={{fontWeight: "bold"}}>Cuadre descontinuado</AlertTitle>
        Ya no es permitido ingresar registros de efectivo en esta pantalla, por favor utilice la opción de <b>Calendario de cierre</b>.
      </Alert>
    </Box>
  );
}

export default CuadreLegacyNotAllowed;